export default "__VITE_ASSET__BP__mx____"